import type { SVGProps } from 'react';

const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.81 22a9.716 9.716 0 0 1-6.937-2.929A10.1 10.1 0 0 1 2 12a10.1 10.1 0 0 1 2.873-7.071A9.716 9.716 0 0 1 11.81 2c.22 0 .43.089.584.246a.85.85 0 0 1 0 1.19.817.817 0 0 1-.584.247A8.06 8.06 0 0 0 6.75 5.476a8.335 8.335 0 0 0-2.878 4.605 8.464 8.464 0 0 0 .545 5.432 8.246 8.246 0 0 0 3.732 3.917 8.019 8.019 0 0 0 5.31.713 8.13 8.13 0 0 0 4.6-2.798 8.41 8.41 0 0 0 1.905-5.103 8.427 8.427 0 0 0-1.61-5.208.854.854 0 0 1 .17-1.177.814.814 0 0 1 1.154.172 10.169 10.169 0 0 1 .896 10.459 9.932 9.932 0 0 1-3.615 4.023A9.672 9.672 0 0 1 11.809 22Z'
      fill='currentColor'
    />
    <path
      d='M17.302 9.299a.813.813 0 0 1-.637-.305.848.848 0 0 1-.175-.695l.648-3.45a.842.842 0 0 1 .347-.538.813.813 0 0 1 .619-.13l3.225.63a.817.817 0 0 1 .528.354.852.852 0 0 1-.219 1.17.818.818 0 0 1-.618.13l-2.415-.471-.493 2.623a.845.845 0 0 1-.285.49.816.816 0 0 1-.525.192Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgRefresh;
